<template>
  <label
    :id="`toggle-${name}`"
    class="relative mb-0 inline-flex h-7 w-12 cursor-pointer rounded-full px-0.5 transition-all"
    :class="[value ? 'bg-success' : 'bg-gray-400', { 'cursor-not-allowed opacity-50': disabled }]"
  >
    <input
      :id="`${name}-input`"
      v-model="model"
      type="checkbox"
      :name="name"
      :disabled="disabled"
      class="absolute left-0 top-0 opacity-0"
    />
    <div class="flex items-center justify-end transition-all" :class="model ? 'w-full' : 'w-6'">
      <span class="flex h-6 w-6 items-center justify-center rounded-full bg-white">
        <span :key="model" class="flex items-center justify-center">
          <fa-icon v-if="model" type="fal" icon="check" class="text-success" />
          <fa-icon v-else type="fal" icon="times" class="text-gray-400" />
        </span>
      </span>
    </div>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
